import { API_KEY } from "./constants/Constant"
export const originals=`discover/tv?api_key=${API_KEY}&with_networks=213`
export const action=`discover/movie?api_key=${API_KEY}&with_genres=28`
export const comedy=`discover/movie?api_key=${API_KEY}&with_genres=35`
export const animation=`discover/movie?api_key=${API_KEY}&with_genres=16`
export const crime=`discover/movie?api_key=${API_KEY}&with_genres=80`
export const family=`discover/movie?api_key=${API_KEY}&with_genres=10751`
export const romance=`discover/movie?api_key=${API_KEY}&with_genres=10749`
export const horror=`discover/movie?api_key=${API_KEY}&with_genres=27`
